import { type IAnswerBase, type IAnswer } from "features/Library/Common/models";

import { type AnswerPropsBase } from "features/Library/Common/QuestionsForm/types";

interface AnswerToRenderPayload<T> {
  Component: (props: AnswerPropsBase<T>) => React.ReactElement;
  castAnswer: (answer: IAnswerBase) => IAnswer<T>;
}

type AnswersMapType<T> = {
  [K in keyof T]: AnswerToRenderPayload<T[K]>;
};

export const asAnswersMap = <TType, TValue>(map: TValue & AnswersMapType<TType>): TValue => {
  return map;
};
